import { render, staticRenderFns } from "./FormListView.vue?vue&type=template&id=5cb28e5b"
import script from "./FormListView.vue?vue&type=script&lang=js"
export * from "./FormListView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports